<div class="wrapper animated fadeIn">
    <div class="container-fluid">
        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Configuración</a></li>
                            <li class="breadcrumb-item"><a href="#">Roles</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title"> Roles</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <!-- Page-Title -->
        <app-info-user></app-info-user>

        <div class="row">
            <div class="col-12">
                <div class="card-box table-responsive">
                    <h4 class="header-title mb-3">Roles</h4>
                    <div class="form-group text-right m-b-0">
                        <button (click)="changeAdd(true)" class="btn btn-custom waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#addrol"><i class="fi-plus"></i>{{"botones.AgregarRol" | translate}}</button>
                    </div>
                    <hr>
                    <div class="row animated fadeIn">
                        <div class="col-md-6">
                            <div class="card-box">
                                <h4 class="m-t-0 header-title">Administración Ticket PAC's</h4>
                                <div class="table-responsive">
                                    <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <table class="table table-hover table-centered m-0" id="dataTableRole">
                                                    <thead>
                                                        <tr>
                                                            <th> - </th>
                                                            <th>Id</th>
                                                            <th>{{ "roles.tablaRole.Nombre" | translate }}</th>
                                                            <th>{{ "roles.tablaRole.Estado" | translate }}</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let role of listRole; let i = index">
                                                            <td><input type="radio" name="selectedRole" (click)="eneableOrDisable(role.idSegRol)" id="{{role.idSegRol}}"></td>
                                                            <td>{{role.idSegRol}}</td>
                                                            <td>{{role.nombre}}</td>
                                                            <td>{{(role.activo)?"Activo":"Inactivo"}}</td>
                                                            <td>
                                                                <button (click)="editRol(role.idSegRol)" class="btn btn-sm btn-purple" data-bs-toggle="modal" data-bs-target="#addrol"><i class="mdi mdi-pencil"></i></button>
                                                            </td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card-box">
                                <h4 class="m-t-0 header-title">Asignación de Módulos</h4>
                                <div class="row">
                                </div>
                                <div class="row mt-4">
                                    <ngx-treeview [config]="config" [items]="items" (filterChange)="onFilterChange($event)" (selectedChange)="values = $event">
                                    </ngx-treeview>
                                </div>
                                <div class="form-group text-right m-b-0">
                                    <button class="btn btn-custom waves-effect waves-light" (click)="saveModules()"><i class="fi-plus"></i>Save Module</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blanco"></div>


<!-- Modal -Rol -->
<div id="addrol" class="modal fade" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bs-dismiss="modal" aria-hidden="true">×</button>
                <h4 class="modal-title" id="myModalLabel">{{ "roles.titulos.CrearRoles" | translate }}</h4>
            </div>
            <div class="modal-body">
                <div class="step">
                    <form [formGroup]="roleForm" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="row">
                            <div class="col-md-4 col-sm-4">
                                <div class="form-group">
                                    <label>{{"roles.crearRoles.Nombre" | translate}}<span class="text-danger">*</span></label>
                                    <input formControlName="nombre" class="form-control required" />
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-4">
                                <div class="form-group">
                                    <label>Tipo Usuario<span class="text-danger">*</span></label>
                                    <dx-select-box id="tipoUsuario" formControlName="tipoUsuario" displayExpr="nombre" valueExpr="idAdmCategoria" class="form-control required" [dataSource]="arrayTipoUsuario"></dx-select-box>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-4">
                                <div class="form-group">
                                    <label>{{"roles.crearRoles.Activo" | translate}}<span class="text-danger">*</span></label>
                                    <dx-select-box formControlName="activo" displayExpr="name" valueExpr="value" class="form-control required" [dataSource]="arrayEstado"></dx-select-box>
                                </div>
                            </div>

                            <div class="col-md-12 col-sm-12">
                                <input type="checkbox" name="allCompany" (change)="checkAllCompanys($event)" id="allCompany"> <label for="comp">Seleccionar todas las empresas</label>
                                <br>
                                <label for="comp">Empresa<span class="text-danger">*</span></label>
                                <p class="text-muted font-14">
                                    Seleccione las Empresas que va a tener a cargo
                                </p>
                                <ng-select2 [data]="multiCompanys" formControlName="companys" [options]="options" id="comp" [width]="500"></ng-select2>
                            </div>
                        </div>
                        <div class="blanco"></div>

                        <div class="form-group text-right m-b-0">
                            <button type="button" (click)="cancel()" data-bs-dismiss="modal" class="btn btn-light waves-effect m-l-5">{{ "botones.Cancelar" | translate }}</button>
                            <button type="button" (click)="update()" *ngIf="edit" class="btn btn-custom waves-effect waves-light">{{ "botones.Actualizar" | translate }}</button>
                            <button type="submit" *ngIf="!edit" class="btn btn-custom waves-effect waves-light">{{ "botones.Guardar" | translate }}</button>
                        </div>
                    </form>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /End modal -->
</div>